import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hint-validation',
  templateUrl: './hint-validation.component.html',
  styleUrls: ['./hint-validation.component.scss']
})
export class HintValidationComponent {

  @Input() hint: string;

}
